<script lang="ts">
    import type {Injector, LocalizeFunction} from '../../../svelte/types';
    import {getContext} from 'svelte';
    import {INJECTOR_KEY, LOCALIZE_KEY} from '../../../svelte/utils';
    import {KpCollectionBulkInsertButtonPresenter} from './kp-collection-bulk-insert-button.presenter';
    import type {Record} from '../../../typings/portaro.be.types';
    import {disabledWhen} from '../../../svelte/svelte-actions/disabled-when';

    export let records: Record[];

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);
    const injector: Injector = getContext(INJECTOR_KEY);

    const presenter: KpCollectionBulkInsertButtonPresenter = injector.getByToken(KpCollectionBulkInsertButtonPresenter.presenterName);

    let isDisabled = false;

    async function insert() {
        isDisabled = true;
        try {
            await presenter.insertMultipleToCollection(records);
        } finally {
            isDisabled = false;
        }
    }

</script>

<template>
    <button type="button"
            class="btn btn-default btn-xs"
            use:disabledWhen={isDisabled}
            on:click={insert}>
        {localize(/* @kp-localization recordCollections.AddSelectedToCollection */ 'recordCollections.AddSelectedToCollection')}
    </button>
</template>
